import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61a9bce2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Edit Service", -1))
const _hoisted_4 = { class: "price" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Save", -1))

import axios, {AxiosError} from "axios"
import {getCurrentInstance, ref} from "vue"
import {useRoute, useRouter} from "vue-router"
import {
  FormInst, FormRules, FormItemRule, NForm, NFormItem,
  NInput, NButton, NSpace, SelectOption, NSelect
} from "naive-ui";
import {ChoicesDto, Service, ServiceDto} from "@/types/Service";
import {QuillEditor} from "@vueup/vue-quill";
import {ValidateError} from "async-validator";

// Initialize router

export default /*#__PURE__*/_defineComponent({
  __name: 'EditService',
  setup(__props) {

const router = useRouter();

// Get service id from params and setup naive-ui messages
const serviceId = useRoute().params.id
const app = getCurrentInstance()
const message = app!.appContext.config.globalProperties.message

// Create ref for Form and Models
const form = ref<FormInst | null>(null)
const model = ref<Service>({} as Service)

var currencies: SelectOption[] = []
const currencyOptions = ref<SelectOption[]>([])

const rules: FormRules = {
  service_name: [
    {
      required: true,
      message: 'Name is required',
      trigger: ['change']
    }
  ],
  currency: [{
    required: true,
    message: 'Currency is required',
    trigger: ['change']
  }],
  price: [
    {
      required: true,
      validator(rule: FormItemRule, value: string) {
        if (!value) {
          return new Error('Price is required')
        } else if (!/^\d*$/.test(value)) {
          return new Error('Price must be numbers')
        }
      },
      trigger: ['change']
    }
  ],
  unit: [{
    required: true,
    message: 'Unit is required',
    trigger: ['change']
  }],
}

function currencySearch(query: string) {
  if (!query.length) {
    currencyOptions.value = currencies
  } else {
    var res: SelectOption[] = currencies.filter((item) => ~item.value.toString().toLowerCase().indexOf(query.toLowerCase()))
    currencyOptions.value = res
  }
}

axios.get("/api/service/currency").then(response => {
  currencies = response.data.map((i: ChoicesDto) => {
    return {value: i.currency_name, label: i.currency_name}
  })
  currencyOptions.value = currencies
}).catch((err: AxiosError) => {
  message.error("Cannot load list of currency", {showIcon: true, closable: true});
})

// Get previous service data
axios.get("/api/service/" + serviceId)
    .then(resp => {
      model.value = resp.data;
    })
    .catch(error => {
      console.error(error);
      message.error("Failed loading service", {showIcon: true, closeable: true});
    })

async function handleSubmit(errors: ValidateError[][] | undefined) {
  if (!errors) {
    let payload = new ServiceDto(model.value);
    axios.patch("/api/service/" + serviceId, payload)
        .then(_val => {
          message.success("Service is successfully updated!", {showIcon: true, closable: true});
          router.push("/service");
        })
        .catch((_err: AxiosError) => {
          message.error("A problem is occurred when updating service", {showIcon: true, closable: true});
        })
  }
}

function handleSubmitButtonClick(e: MouseEvent) {
  e.preventDefault();
  form.value!.validate(handleSubmit).catch(_error => {
    message.error("Form is invalid", {showIcon: true, closable: true})
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NSpace), {
        vertical: "",
        align: "center"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_unref(NForm), {
        ref_key: "form",
        ref: form,
        model: model.value,
        rules: rules
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NFormItem), {
            id: "serviceNameForm",
            path: "service_name",
            label: "Name"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInput), {
                id: "service_name",
                value: model.value.service_name,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((model.value.service_name) = $event)),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                size: "large",
                placeholder: "Service Name"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_unref(NFormItem), {
            id: "currencyForm",
            path: "currency",
            label: "Currency"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSelect), {
                id: "currency",
                placeholder: "Select Currency",
                value: model.value.currency,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((model.value.currency) = $event)),
                options: currencyOptions.value,
                filterable: "",
                clearable: "",
                remote: "",
                onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                onSearch: currencySearch,
                size: "large"
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(NFormItem), {
              id: "priceForm",
              path: "price",
              label: "Price"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  id: "price",
                  value: model.value.price,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((model.value.price) = $event)),
                  onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                  size: "large",
                  placeholder: "100000"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createTextVNode(" per "),
            _createVNode(_unref(NFormItem), {
              id: "unitForm",
              path: "unit",
              label: "Unit"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  id: "unit",
                  value: model.value.unit,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((model.value.unit) = $event)),
                  onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                  size: "large",
                  placeholder: "Hour"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          (model.value.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createTextVNode(" Description "),
                _createVNode(_unref(QuillEditor), {
                  theme: "snow",
                  "content-type": "html",
                  content: model.value.description,
                  "onUpdate:content": _cache[8] || (_cache[8] = ($event: any) => ((model.value.description) = $event)),
                  placeholder: "Description"
                }, null, 8, ["content"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_unref(NButton), {
            id: "submitBtn",
            type: "primary",
            "attr-type": "submit",
            size: "large",
            onClick: handleSubmitButtonClick
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}
}

})